export default () => ({
    product: shopifyData.product,
    selectedVariantId: null,
    selectedVariant: null,
    price: shopifyData.product.price,
    compareAtPrice: shopifyData.product.compare_at_price,
    showError: false,

    init() {
        this.$watch('selectedVariantId', (value) => {
            this.selectedVariant = this.product.variants.find(
                (variant) => variant.id === Number(value)
            )

            this.$nextTick(() => {
                this.price = this.selectedVariant.price
                this.compareAtPrice = this.selectedVariant.compare_at_price
                this.reloadInventoryApp(this.selectedVariant)
            })
        })

        if (this.product.variants.length === 1) {
            this.selectedVariantId = this.product.variants[0].id
        }

        if (window.inventoryInfo) {
            this.reloadInventoryApp(shopifyData.product.firstAvailableVariant)
        } else {
            document.addEventListener('inventoryInfo.appLoaded', () => {
                this.reloadInventoryApp(
                    shopifyData.product.firstAvailableVariant
                )
            })
        }

        // On the product page we need the injected mark-up from Harper so the
        // Harper modal can be shown. We are intercepting the event and adding 
        // the product to the cart.
        this.$nextTick(() => {
            const harperBtn = document.querySelector(
                '#hcxproduct-checkoutcta-button'
            )

            if (harperBtn) {
                harperBtn.addEventListener('click', (e) => {
                    e.stopImmediatePropagation()
                    e.preventDefault()
                    this.addToCart(e)
                }, true)
            }
        })
    },

    addToCart(e) {
        if (!this.selectedVariantId) {
            this.showError = true
            return
        }

        this.showError = false

        this.$dispatch('cart:addItem', {
            id: this.selectedVariantId,
            handle: this.product.handle,
            price: this.price,
            quantity: 1,
            el: e.target,
        })
    },
    reloadInventoryApp(variant) {
        if (!variant) {
            return
        }

        window.inventoryInfo.api.loadApp({
            handle: this.product.handle,
            variant: Number(variant.id),
        })
    },
})
